/*
 * Publishes the sticky header's height as --circles-header-height.
 *
 * Horizon derives its sticky offsets from --header-height, which its own
 * header component sets. This theme replaces that header, so nothing sets it
 * and every sticky element pins to the very top of the viewport — underneath
 * our header. The height is not a constant either: the utility bar and the
 * navbar change size across breakpoints, so it is measured rather than typed
 * into the stylesheet.
 */
const header = document.getElementById('header-group');

if (header) {
  const publishHeight = () => {
    const { height } = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--circles-header-height', `${Math.round(height)}px`);
  };

  publishHeight();
  new ResizeObserver(publishHeight).observe(header);
}
